import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { BrowserRouter } from 'react-router-dom'
import { AuthProvider } from './context/AuthContext'
import { ModalProvider } from './context/ModalContext'
import { ThemeProvider } from './context/ThemeContext'
import { SectionErrorBoundary } from './components/ErrorBoundary'
import { AppRoutes } from './routes'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { retry: 1, staleTime: 15_000 },
  },
})

export function App() {
  return (
    <SectionErrorBoundary>
      <ThemeProvider>
        <QueryClientProvider client={queryClient}>
          <AuthProvider>
            <ModalProvider>
              <BrowserRouter>
                <AppRoutes />
              </BrowserRouter>
            </ModalProvider>
          </AuthProvider>
        </QueryClientProvider>
      </ThemeProvider>
    </SectionErrorBoundary>
  )
}
